import type { AppRouteConfigView } from "shared/mappers/database/app-route/app-route-config/app-route-config";

export const isPublicRoute = (route?: Partial<AppRouteConfigView>) => {
  return (
    route?.isPublic &&
    route?.everyTag?.length === 0 &&
    route?.someTag?.length === 0 &&
    route?.noneTag?.length === 0
  );
};
